import {Component, OnInit, ViewChild, Input, AfterViewInit, OnDestroy} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {environment} from '../../../../../../../environments/environment';
import {UserService} from '../../../../../../shared/services/user/user.service';
import {ProjectService} from '../../../../../../shared/services/project/project.service';
import {TranslateService} from '@ngx-translate/core';
import {StatesService} from '../../../../../../shared/services/state/states.service';
import {ToastrService} from 'ngx-toastr';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {ProjectUserAddListComponent} from '../project-user-add-list/project-user-add-list.component';
import {Subscription} from 'rxjs/index';
import {AuthenticationService} from '../../../../../../shared/services/authentication/authentication.service';
import {ProjectUser} from '../../../../../../shared/classes/project-user/project-user';
import {ModalService} from '../../../../../../shared/services/modal/modal.service';


@Component({
    selector: 'app-project-user-remove-list',
    templateUrl: './project-user-remove-list.component.html',
    styleUrls: ['./project-user-remove-list.component.css']
})
export class ProjectUserRemoveListComponent implements OnInit, OnDestroy {
    public displayedColumns: string[] = ['userRoles', 'userEmail', 'userFirstname', 'userLastname', 'mainRole', 'action'];
    public projectUsers: MatTableDataSource<any>;
    public countUsers: number = null;
    public pageSizeOptions = environment.pageSizeOptions;
    public pageSize = environment.pageSize;
    public showSpinner: boolean = false;
    public faPlus = faPlus;
    public roles = [{value: 1, name: 'client'}, {value: 2, name: 'installer'}];
    public rolesSelected: string = null;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Input('projectId') projectId: number = null;
    @Input('projectLevel') projectLevel: number = null;
    @Input('readOnly') readOnly: boolean = false;

    private reloadProjectUserRemove: Subscription;


    constructor(private userService: UserService,
                private projectService: ProjectService,
                private statesService: StatesService,
                private toastr: ToastrService,
                private translate: TranslateService,
                private modalService: ModalService,
                public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        if (this.readOnly) {
            this.displayedColumns = ['userRoles', 'userEmail', 'userFirstname', 'userLastname', 'mainRole'];
        }

        this.reloadProjectUserRemove = this.statesService.reloadProjectUserRemove.subscribe(() => {
            this.initList();
        });
        this.initList();
    }

    ngOnDestroy() {
        this.reloadProjectUserRemove.unsubscribe();
    }

    openModal() {
        const modalRef = this.modalService.openNgbModal(ProjectUserAddListComponent, {size: 'lg'});
        modalRef.componentInstance.projectId = this.projectId;
        modalRef.componentInstance.projectLevel = this.projectLevel;
    }

    filterListByRole(role: string) {
        if (this.rolesSelected !== role) {
            this.rolesSelected = role;
        } else {
            this.rolesSelected = null;
        }
        this.initList();
    }


    private initList() {

        if (!isNaN(this.projectId)) {
            this.showSpinner = true;
            this.projectService.getProject(this.projectId, 'users')
                .subscribe(
                    (data: any) => {
                        let newUserList: any[] = [];
                        data.project_users.forEach((d) => {
                            d.projectUserId = d.id;
                            d.userId = d.user.id;
                            d.userEmail = d.user.email;
                            d.userFirstname = d.user.firstname;
                            d.userLastname = d.user.lastname;
                            d.userRoles = d.user.roles;
                            d.user = null;
                            if (this.rolesSelected !== null) {
                                if (d.userRoles.includes('ROLE_' + this.rolesSelected.toUpperCase())) {
                                    newUserList.push(d);
                                }
                            } else {
                                newUserList.push(d);
                            }
                        });
                        this.countUsers = newUserList.length;
                        this.projectUsers = new MatTableDataSource(newUserList);
                        this.projectUsers.filter = null;
                        this.projectUsers.sort = this.sort;
                        this.projectUsers.paginator = this.paginator;
                        this.showSpinner = false;
                    },
                    (error2) => {
                        this.showSpinner = false;
                    }
                );
        } else {
            this.projectId = null;
        }

    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.projectUsers.filter = filterValue;
    }

    public patchProjectUserMainBusiness(projectUserid: number, value: boolean = false) {
        let projectUser = new ProjectUser();
        projectUser.isMainBusiness = value;
        this.patchProjectuser(projectUserid, projectUser);
    }

    public patchProjectUserMainClient(projectUserid: number, value: boolean = false) {
        let projectUser = new ProjectUser();
        projectUser.isMainClient = value;
        this.patchProjectuser(projectUserid, projectUser);
    }

    public getClientOrInstallerRoles(roles: any[]) {
        return this.userService.getClientOrInstallerRoles(roles);
    }


    public removeUserToProject(userId: number, userEmail: string) {
        this.showSpinner = true;
        this.projectService.deleteProjectUser(userId)
            .subscribe(
                data => {
                    this.toastr.warning(userEmail + ' ' + this.translate.instant('REMOVED_FROM_PROJECT'), this.translate.instant('WARNING'));
                    this.showSpinner = false;
                    this.initList();
                },
                error2 => {
                    this.showSpinner = false;
                });
    }

    private patchProjectuser(projectUserid: number, projectUser: ProjectUser) {
        this.showSpinner = true;
        this.projectService.patchProjectUser(projectUserid, projectUser)
            .subscribe(
                () => {
                    this.toastr.info(this.translate.instant('USER_MODIFIED'), this.translate.instant('SUCCESS'));
                    this.initList();
                    this.showSpinner = false;
                },
                error1 => {
                    this.showSpinner = false;
                });
    }

}
